export default {
  SHORT_TO_LONG: 'shortToLong',
  LONG_TO_SHORT: 'longToShort',
};
